import { REQUEST_B_A} from '../../../const';

export default function BAReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_B_A:
      return action.boja_a;
    default:
      return state;
  }
}